import createModule from "../createModule"
import view from "./view"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getTeamId, getTeamRole, getTeamTokens, getTokens, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    teamAlias: props.params.teamAlias,
  }),
  required: ["account", "teamAlias"],
  data: [{
    resource: "tokens",
    url: () => {
      return {
        id: "accountTokens",
        query: `{
          tokens {
            id
            name
            createdAt
          }
        }`,
      }
    },
  }, {
    resource: "teamTokens",
    url: ({ teamAlias }) => {
      return {
        id: `team-tokens-${teamAlias}`,
        query: `query ($teamId: IdOrAlias!) {
          team (id: $teamId) {
            id
            name
            role
            tokens {
              id
              name
              teamRole
              createdAt
              updatedAt
            }
          }
        }`,
        variables: {
          teamId: teamAlias,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state, props),
    teamId: getTeamId(state, props),
    teamRole: getTeamRole(state, props),
    tokens: getTokens(state, props),
    teamTokens: getTeamTokens(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
